import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table table-responsive-md border border-gray" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "First Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Primary Phone"),
    /*#__PURE__*/_createElementVNode("th", null, "Relationship"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_7 = ["colspan"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "No Contacts Found.", -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "table-error"
}
const _hoisted_11 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_EmergencyContactsRow = _resolveComponent("EmergencyContactsRow")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    (_ctx.isLoading || _ctx.isError || !_ctx.hasData)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
          _createCommentVNode(" LOADING "),
          (_ctx.isLoading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  class: "table-loading"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_5))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" EMPTY "),
          (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_9, 8 /* PROPS */, _hoisted_7)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" ERROR "),
          (!_ctx.isLoading && _ctx.isError)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _createElementVNode("td", { colspan: _ctx.columns }, [
                  _createVNode(_component_ErrorMessageHandler, {
                    title: "Contact list",
                    "try-again": _ctx.getContacts
                  }, null, 8 /* PROPS */, ["try-again"])
                ], 8 /* PROPS */, _hoisted_11)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.contacts, (contact, index) => {
          return (_openBlock(), _createElementBlock("tbody", {
            key: contact.id
          }, [
            _createVNode(_component_EmergencyContactsRow, {
              contact: contact,
              "is-re-order-requested": _ctx.isReOrderRequested,
              "patient-primary-address": _ctx.patientPrimaryAddress,
              columns: _ctx.columns,
              "is-palliative": _ctx.isPalliative,
              "patient-id": _ctx.patientId,
              "total-contacts": _ctx.totalContacts,
              "relationships-enum": _ctx.relationshipsEnum,
              "contact-roles-enum": _ctx.contactRolesEnum,
              "cahps-survey-contact-enum": _ctx.cahpsSurveyContactEnum,
              "refresh-list": _ctx.getContacts,
              "move-up": _ctx.moveUp,
              "move-down": _ctx.moveDown,
              "update-contact": _ctx.updateEmergencyContact,
              "delete-emergency-contact": _ctx.deleteEmergencyContact,
              "make-contact-primary": _ctx.makeEmergencyContactPrimary,
              referral: _ctx.referral,
              index: index,
              "is-editing": _ctx.isEditing,
              onUpdateIsEditing: _ctx.updateIsEditing
            }, null, 8 /* PROPS */, ["contact", "is-re-order-requested", "patient-primary-address", "columns", "is-palliative", "patient-id", "total-contacts", "relationships-enum", "contact-roles-enum", "cahps-survey-contact-enum", "refresh-list", "move-up", "move-down", "update-contact", "delete-emergency-contact", "make-contact-primary", "referral", "index", "is-editing", "onUpdateIsEditing"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
  ]))
}